Vue.component("donation-form", {
    mixins: [
        Mixins.submitForm,
    ],
    components: {
        'vue-recaptcha': VueRecaptcha
    },
    template: `
        <div class="form-block form-block--primary">
            <div class="form-block__wrapper">
                <form v-show="show"
                      :action="action"
                      :class="{'form--loading': loading}"
                      class="donation-block__form form"
                      ref="form"
                      @submit.prevent="onSubmit">

                    <div v-show="alert.message"
                         ref="alert"
                         :class="['form-message', 'form-message--active', 'form-message--' + alert.type]"
                    >
                        <div class="form-message__content" v-text="alert.message"></div>
                        <span class="form-message__icon form-message__icon--success">
                            <svg viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1671 566q0 40-28 68l-724 724-136 136q-28 28-68 28t-68-28l-136-136-362-362q-28-28-28-68t28-68l136-136q28-28 68-28t68 28l294 295 656-657q28-28 68-28t68 28l136 136q28 28 28 68z"/>
                            </svg>
                        </span>
                        <span class="form-message__icon form-message__icon--error">
                            <svg width="32" height="32" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1088 1248v224q0 26-19 45t-45 19h-256q-26 0-45-19t-19-45v-224q0-26 19-45t45-19h256q26 0 45 19t19 45zm30-1056l-28 768q-1 26-20.5 45t-45.5 19h-256q-26 0-45.5-19t-20.5-45l-28-768q-1-26 17.5-45t44.5-19h320q26 0 44.5 19t17.5 45z"/>
                            </svg>
                        </span>
                    </div>

                    <div v-if="paymentStatus"
                         :class="['form-message', 'form-message--active', 'form-message--error']"
                    >
                        <div class="form-message__content" v-text="trans('payment.message.' + paymentStatus)"></div>
                    </div>

                    <h2 class="donation-block__form-title">{{ trans('heading.title') }}</h2>

                    <h5>{{ trans('heading.frequency') }}</h5>
                    <div v-for="(option, index) in options.frequency" class="form__group form__group--vertical">
                        <input
                            v-model="data.frequency"
                            type="radio"
                            name="frequency"
                            :id="'frequency' + index"
                            :value="option"
                            required
                        >
                        <label :for="'frequency' + index" class="form__label" v-html="option"></label>
                    </div>

                    <p class="donation-block__form-message small">{{ trans('message.periodic') }}</p>

                    <h5>{{ trans('heading.amount') }}</h5>
                    <div class="donation-block__amount-wrapper form__group">
                        <div v-for="(option, index) in options.amount" class="donation-block__amount">
                            <input
                                v-model="data.amount"
                                type="radio"
                                name="amount"
                                :id="'amount' + index"
                                :value="option"
                                class="donation-block__amount-radio form__input"
                                required
                            >
                            <label :for="'amount' + index" class="form__label" v-html="option"></label>
                        </div>
                    </div>

                    <div v-if="data.amount === trans('label.other_amount')" class="form__group">
                        <label for="customAmount" class="form__label" v-html="trans('label.other_amount')"></label>
                        <input
                            v-model="data.customAmount"
                            type="number"
                            id="customAmount"
                            name="customAmount"
                            required
                            min="1"
                            step="0.01"
                        >
                    </div>

                    <h5>{{ trans('heading.personal_info') }}</h5>

                    <div v-for="(option, index) in options.gender" class="form__group form__group--vertical">
                        <input
                            v-model="data.gender"
                            type="radio"
                            name="gender"
                            :id="'gender' + index"
                            :value="option"
                        >
                        <label :for="'gender' + index" class="form__label" v-html="option"></label>
                    </div>

                    <div class="form__group">
                        <label for="firstName" class="form__label" v-html="trans('first_name.label')"></label>
                        <input
                            v-model="data.firstName"
                            type="text"
                            name="firstName"
                            id="firstName"
                            required
                        >
                    </div>

                    <div class="form__group">
                        <label for="lastName" class="form__label" v-html="trans('last_name.label')"></label>
                        <input
                            v-model="data.lastName"
                            type="text"
                            name="lastName"
                            id="lastName"
                            required
                        >
                    </div>

                    <div class="form__group">
                        <label for="email" class="form__label" v-html="trans('email.label')"></label>
                        <input
                            v-model="data.email"
                            type="email"
                            name="email"
                            id="email"
                            required
                        >
                    </div>

                    <div class="form__group">
                        <input
                            v-model="data.privacy"
                            type="checkbox"
                            class="form__input"
                            name="privacy"
                            id="privacy"
                            required
                        >
                        <label for="privacy" class="form__label" v-html="trans('privacy.label')"></label>
                    </div>

                    <vue-recaptcha
                        ref="recaptcha"
                        size="invisible"
                        :sitekey="recaptchaSiteKey"
                        @verify="onCaptchaVerified"
                    ></vue-recaptcha>

                    <button
                        type="submit"
                        class="donation-block__submit button button--white button--clean"
                        :disabled="loading"
                    >
                        <span v-text="trans('button.send')"></span>
                    </button>
                </form>
            </div>
        </div>
    `,
    props: {
        action: {
            type: String,
            required: true
        },
        translations: {
            type: Object,
            required: true
        },
        paymentStatus: {
            type: String,
            default: ''
        },
        recaptchaSiteKey: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            loading: false,
            show: true,
            alert: {
                message: '',
                type: ''
            },
            hasCaptcha: true,
            captchaExecuted: false,
            captchaToken: null,
            data: {
                frequency: null,
                amount: null,
                customAmount: null,
                gender: null,
                firstName: null,
                lastName: null,
                email: null,
                privacy: false
            },
            options: {
                frequency: [],
                amount: [],
                gender: []
            }
        }
    },
    created() {
        // Initialize options from translations
        if (this.translations.option) {
            this.options.frequency = [
                this.translations.option.frequency.once,
                this.translations.option.frequency.monthly,
                this.translations.option.frequency.annually,
            ];
            this.options.amount = [
                this.translations.option.amount.option1,
                this.translations.option.amount.option2,
                this.translations.option.amount.option3,
                this.translations.label.other_amount,
            ];
            this.options.gender = [
                this.translations.option.gender.woman,
                this.translations.option.gender.man,
            ];
        }
    },
    methods: {
        trans(key) {
            const keys = key.split('.');
            let value = this.translations;

            for (let k of keys) {
                if (value && value[k]) {
                    value = value[k];
                } else {
                    return key;
                }
            }

            return value;
        },
        onSubmit() {
            if (!this.hasCaptcha || this.captchaExecuted) {
                this.submitForm();
            } else {
                this.$refs.recaptcha.execute();
            }
        },
        onCaptchaVerified(token) {
            this.captchaExecuted = true;
            this.captchaToken = token;
            this.submitForm();
        },
        onCaptchaExpired() {
            this.captchaExecuted = false;
            this.captchaToken = null;
            if (this.$refs.recaptcha) {
                this.$refs.recaptcha.reset();
            }
        },
        onCaptchaError(error) {
            this.alert.message = this.trans('message.error');
            this.alert.type = 'error';
        },
        submitForm() {
            this.loading = true;
            this.alert.message = '';

            const formData = new FormData();

            // Add all form data
            Object.keys(this.data).forEach(key => {
                if (this.data[key] !== null) {
                    formData.append(key, this.data[key]);
                }
            });

            // Add reCAPTCHA token
            if (this.captchaToken) {
                formData.append('_recaptcha', this.captchaToken);
            }

            axios({
                method: 'post',
                url: this.action,
                data: formData
            }).then(response => {
                this.loading = false;

                if (response.data.redirect) {
                    window.location.href = response.data.redirect;
                } else if (response.data.message) {
                    this.alert.message = response.data.message;
                    this.alert.type = 'success';
                    this.show = false;
                }
            }).catch(error => {
                this.loading = false;
                this.captchaExecuted = false;
                this.captchaToken = null;

                if (this.$refs.recaptcha) {
                    this.$refs.recaptcha.reset();
                }

                if (error.response && error.response.data) {
                    this.alert.message = error.response.data.message || this.trans('message.error');
                    this.alert.type = 'error';
                } else {
                    this.alert.message = this.trans('message.error');
                    this.alert.type = 'error';
                }

                if (this.$refs.alert) {
                    this.MoveToInstance.move(this.$refs.alert.$el);
                }
            });
        }
    }
});
